import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";
import { postToast, ToastType } from "core/src/slices/ui/useCases/postToast/postToast.use-case";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { EtlApiTarget } from "etl/types";

export type TriggerOutputCSVGeneratorRequest = {
	triggerFilters?: string[]
}

export const triggerOutputCSVGenerator = createAppAsyncThunk<void, TriggerOutputCSVGeneratorRequest>(
	"formStep/triggerOutputCSVGenerator",
	async ({ triggerFilters = [] }, { getState, extra, dispatch, rejectWithValue }) => {
		try {
			const { selectedEtlImportUuid } = getState().etlData;
			if (!selectedEtlImportUuid) return;

			await extra.etlClient.trigger(EtlApiTarget.GENERATE_OUTPUT_CSV_API, selectedEtlImportUuid, { triggerFilters })
			dispatch(postToast({ message: "CSV d'export générés avec succès", type: ToastType.SUCCESS }))


		} catch (error: any) {
			dispatch(displayApiErrorToast(error.response))
			throw rejectWithValue(error.response.data.message);
		}
	},
	{
		condition: (_, { getState }) => {
			if (getState().formStep.preProcessRunning) return false;
		}
	}
);
